import { render, staticRenderFns } from "./EspecificacionesAdd.vue?vue&type=template&id=022d1e7b&"
import script from "./EspecificacionesAdd.vue?vue&type=script&lang=js&"
export * from "./EspecificacionesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports